module.exports = __webpack_public_path__ + "static/media/lullaby.1e3e810a.mp3";